import { PartialType, ApiProperty } from '@nestjs/swagger';
import { CreateNewsfeedDto } from './create-newsfeed.dto';

export class UpdateNewsfeedDto extends PartialType(CreateNewsfeedDto) {
  @ApiProperty({
    description: 'The title of the newsfeed',
    example: 'Updated Announcement',
    required: false
  })
  title?: string;

  @ApiProperty({
    description: 'The subject of the newsfeed',
    example: 'Updated Company Update',
    required: false
  })
  subject?: string;

  @ApiProperty({
    description: 'The detailed description of the newsfeed',
    example: 'We have updated our previous announcement...',
    required: false
  })
  description?: string;

  @ApiProperty({
    description: 'Allow live edit',
    example: true,
    required: false
  })
  is_live_edit?: boolean;

  @ApiProperty({
    description: "Make newsfeed public or private",
    example: false,
    required: false
  })
  is_public?: boolean;

  @ApiProperty({
    description: 'The audio of the newsfeed',
    example: 'https://example.com/audio.mp3',
    required: false
  })
  audio?: string;

  @ApiProperty({
    description: 'The tags or keyword for search and categorization',
    example: ['company', 'update'],
    required: false
  })
  tags?: string[];
}
